import React from 'react'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'
import ShieldIcon from 'components/material-symbol/icons/Shield'
import { PGA_COM_HOST } from 'env'
import AccountCard from './account-card'

const PLATFORM_POLICIES_URL = `${PGA_COM_HOST}/platform-user-policies`

const LegalPolicies = ({ classes }) => (
  <AccountCard title="Legal & Policies" classes={classes}>
    <Link
      href={PLATFORM_POLICIES_URL}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      className={classes.policyLink}
    >
      <Box className={classes.policyIconWrap}>
        <ShieldIcon className={classes.policyIcon} />
      </Box>
      <Box className={classes.policyCopy}>
        <Typography className={classes.policyTitle}>
          Platform Policies
        </Typography>
        <Typography className={classes.policyCaption}>
          Security, privacy, and account handling information.
        </Typography>
      </Box>
      <ChevronRightIcon className={classes.policyChevron} />
    </Link>
  </AccountCard>
)

export default LegalPolicies
